export const COOKIE_CONSENT_KEY = "mp_cookies";
export const COOKIE_CONSENT_ACCEPTED_VALUE = "accepted";
export const COOKIE_CONSENT_REJECTED_VALUE = "rejected";
